import * as ko from 'knockout';

import { EVENTS } from 'Core/Constant';
import { IButtonConfig } from 'Core/Controls/PortletBar/Interfaces/IButtonConfig';
import { PortletBarButton } from 'Core/Controls/PortletBar/Managers/Buttons/PortletBarButton';
import { SettingsButtonViewModel } from 'Core/Controls/PortletBar/Models/Buttons/SettingsButtonViewModel';
import { ITooltipConfig } from 'Core/KnockoutExtentions/TooltipExtention';

export class SettingsButton extends PortletBarButton {
    ViewModel: SettingsButtonViewModel;

    constructor(buttonName: string, buttonConfig: IButtonConfig) {
        super(buttonConfig);
        this.ViewModel = new SettingsButtonViewModel(buttonName, buttonConfig);
        this.Tooltip = ko.observable<ITooltipConfig>({
            content: this._labels.PORTLET_SETTINGS,
            onlyOnOverflow: true,
            pointer: 'left',
            addClass: 'pointer-events-none',
        });
    }

    OnClickEvent() {
        return EVENTS.PORTLETS.PORTLET_BAR.CONTROL_BUTTONS.SETTINGS_BUTTON_CLICKED;
    }

    OnClick() {
        this.ViewModel.PropsOpened(!this.ViewModel.PropsOpened());
        this.Trigger(this.OnClickEvent());
    }

    SaveSettings() {
        this.ViewModel.PropsOpened(false);
        this.Trigger(EVENTS.PORTLETS.RUNTIME_SETTINGS_UPDATED);
    }

    protected GetButtonTemplateFolder() {
        return `${super.GetButtonTemplateFolder()}/Settings`;
    }
}
